__webpack_require__.p = "/static/bocco/rental/";